const ModuleLeft = () => {
  return <div className="left"></div>;
};

export default ModuleLeft;
